import { DownArrow } from '../assets';
import { cn } from '../lib';
import { Button, ButtonProps } from './button';
import { Typography } from './typography';

export const ArrowOpener = ({ children, className, ...props }: ButtonProps) => {
  return (
    <Button
      className={cn(
        'flex justify-normal gap-x-1 bg-surface-00-transparent p-0 [&_svg]:size-5',
        className,
      )}
      variant="lead"
      {...props}
    >
      <Typography variant="16-m-caps">{children}</Typography>
      <DownArrow className="text-base-500" />
    </Button>
  );
};
